import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { PublicUserEntity } from './public-user.entity';

@Index('fk_client__id', ['fkClientId'], {})
@Index('fk_public_user__id', ['fkPublicUserId'], {})
@Entity('client_public_user')
export class ClientPublicUserEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', { name: 'fk_public_user__id', unsigned: true })
	public fkPublicUserId!: number;

	@Column('tinyint', { name: 'isClientActive', width: 1, default: () => "'0'" })
	public isClientActive!: boolean;

	@Column('tinyint', { name: 'isEnabled', width: 1, default: () => "'1'" })
	public isEnabled!: boolean;

	@Column('decimal', {
		name: 'orderApprovalLimit',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public orderApprovalLimit!: string | null;

	@ManyToOne(() => ClientEntity, (client) => client.clientPublicUsers, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@ManyToOne(
		() => PublicUserEntity,
		(publicUser) => publicUser.clientPublicUsers,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: 'fk_public_user__id', referencedColumnName: 'id' }])
	public fkPublicUser!: PublicUserEntity;
}
